export enum ArticleType {
  GENERIC = 'Generic',
  GRANTEE = 'Grantee news',
  MELLON_IN_THE_NEWS = 'Mellon news',
  PAST_EVENT = 'Past event',
  REPORT = 'Report',
  VOICES = 'Voices',
  STORY = 'Story',
}
